import {Constants} from "@/plugins/constants";
import librariesConfig from '@/../clientConfig/libraries'
import cardConfig from '@/../clientConfig/card'
import evaluationConfig from '@/../clientConfig/evaluation'
import talentMatrixConfig from '@/../clientConfig/talentMatrix'
import knowledgeBaseConfig from '@/../clientConfig/knowledgeBase'
import cardStagesConfig from '@/../clientConfig/cardStages'
import cardStageNegotiationsConfig from '@/../clientConfig/cardStageNegotiations'
import cardSectionsConfig from '@/../clientConfig/cardSections'
import cardStatusesConfig from '@/../clientConfig/cardStatuses'
import commentConfig from '@/../clientConfig/comment'
import scalesConfig from '@/../clientConfig/scales'
import massActionsConfig from '@/../clientConfig/massActions'
import matrixConfig from '@/../clientConfig/matrix'
import settingsConfig from '@/../clientConfig/settings'
import userConfig from '@/../clientConfig/user'
import userDeputyConfig from '@/../clientConfig/deputies'
import exportImportConfig from '@/../clientConfig/exportImport'
import authConfig from '@/../clientConfig/auth'
import i18nConfig from '@/../clientConfig/i18n'
import homeConfig from '@/../clientConfig/home'
import cascadingConfig from '@/../clientConfig/cascading'


const libraries = {
    getTypes(){
        return librariesConfig.types;
    },
    getTypeConfig(libraryType){
        return librariesConfig.types[libraryType];
    },
    getTypeShowName(libraryType){
        return this.getTypeConfig(libraryType).showName;
    },
    getElementsTableBorder(){
        return !!librariesConfig.elements_table_border;
    },
    getElementsTableColumns(libraryType){
        // Можем подсовывать разные конфигурации для разных библиотек
        if( !libraryType || !this.getTypeConfig(libraryType).columnsConfig ){
            return librariesConfig.elements_table_columns;
        }
        const configKeyName = this.getTypeConfig(libraryType).columnsConfig;
        return librariesConfig[configKeyName];
    },
    getElementChangePropagationMode(){
        return librariesConfig.element_change_propagation_mode;
    },
    getElementEditDialogWidth(){
        return librariesConfig.element_edit_dialog_width ? librariesConfig.element_edit_dialog_width : 40;
    },

    getFolderModeratorsConfigEnabled(){
        return librariesConfig.folder_moderators_config_enabled ? librariesConfig.folder_moderators_config_enabled : false;
    },
    getFolderVisibilityConfigEnabled(){
        return librariesConfig.folder_visibility_config_enabled ? librariesConfig.folder_visibility_config_enabled : false;
    },
    getFolderVisibilityConfigMode(){
        return librariesConfig.folder_visibility_config_mode ? librariesConfig.folder_visibility_config_mode : Constants.library.folderVisibilityConfigMode.MODE_BLACKLIST;
    },
    getLibraryElementsSearchEverywhereEnabled(){
        return librariesConfig.library_elements_search_everywhere_enabled ? librariesConfig.library_elements_search_everywhere_enabled : false;
    },
}

const card = {
    getAvailablePeriods(){
        return cardConfig.available_periods;
    },
    getAvailableSectionsByPeriod(cardPeriod){
        if( !cardConfig.available_sections_for_period[cardPeriod] ){
            return [];
        }
        return cardConfig.available_sections_for_period[cardPeriod];
    },

    getCardsPageFiltersTemplate(){
        let templatePath = cardConfig.cards_page_filters.template;
        return () => import(`@/${templatePath}`);
    },
    getCardSelectablePageColumns(){
        return cardConfig.card_selectable_page_columns;
    },
    getCardsPageColumns(){
        return cardConfig.cards_page_columns;
    },
    getCardsPageSearchExpand(){
        if( !cardConfig.cards_search_expand || !cardConfig.cards_search_expand.length ){
            return ['info', 'user', 'current_stage', 'current_stage.current_negotiation.user', 'permissions'];
        }
        return cardConfig.cards_search_expand;
    },

    getCardHeaderElements(){
        return cardConfig.card_header_elements;
    },
    getCardHeaderTemplate(){
        if (!cardConfig.card_header_template) {
            return () => import(`@/components/cards/CardHeader/CardHeaderFromProps`);
        }
        const templatePath = cardConfig.card_header_template;
        return () => import(`@/${templatePath}`);
    },
    getCardCreateInfoTemplate(){
        if (!cardConfig.cards_create_info_template) {
            return null;
        }
        const templatePath = cardConfig.cards_create_info_template;
        return () => import(`@/${templatePath}`);
    },
    isCardNextAndPreviousButtons(){
        return cardConfig.is_card_next_and_previous_buttons === true;
    },
    getAgreeButtonsTemplate() {
      if (!cardConfig.card_agree_buttons_template) {
        return () => import(`@/components/cards/AgreeButtons.vue`);
      }
      const templatePath = cardConfig.card_agree_buttons_template;
      return () => import(`@/${templatePath}`);
    },
    getErrorsIcon(){
      return cardConfig.errors_icon || 'fas fa-exclamation-triangle';
    },
}

const evaluation = {
    isEnabled(){
        return evaluationConfig.enabled === true;
    },
    isResultSetting(){
        return evaluationConfig.results_visibility_configuration_enabled === true;
    },
}

const talentMatrix = {
    isEnabled(){
        return talentMatrixConfig.enabled === true;
    },
}

const knowledgeBase = {
    isEnabled(){
        return knowledgeBaseConfig.enabled === true;
    },
}

const cardStages = {
    getTypes() {
        return Object.keys(cardStagesConfig.types);
    },
    getTypesConfig() {
        return cardStagesConfig.types;
    },
    getStageConfig(type) {
        return cardStagesConfig.types[type];
    },
    getStageShowName(type) {
        return cardStagesConfig.types[type]?.showName;
    },
    ifStageHideOnCardCreate(type) {
        return cardStagesConfig.types[type].hideOnCardCreate;
    },
    getDynamicStageButtonText(type) {
        return cardStagesConfig.types[type].dynamicAddButtonText;
    },
    getCardStagesBlockTemplate(){
        if (!cardStagesConfig.card_stages_block_template) {
            return () => import(`@/components/cards/CardStagesBlock/CardStagesBlock`);
        }
        const templatePath = cardStagesConfig.card_stages_block_template;
        return () => import(`@/${templatePath}`);
    },
    isRequiredStageDates(){
        return cardStagesConfig?.is_required_stage_dates === true;
    },
}


const cardStageNegotiations = {
    getDefaultNegotiationTypes() {
        return cardStageNegotiationsConfig.default_negotiations;
    },
    getNegotiationTypesForStage(stageType){
        if( cardStageNegotiationsConfig.stage_negotiations && cardStageNegotiationsConfig.stage_negotiations[stageType] ){
            return cardStageNegotiationsConfig.stage_negotiations[stageType];
        }
        return this.getDefaultNegotiationTypes();
    },


    getNegotiationTypesConfig() {
        return cardStageNegotiationsConfig.types;
    },
    getNegotiationNameByType(type) {
        return cardStageNegotiationsConfig.types[type]?.showName
    }
}

const cardStatuses = {
    getStatuses() {
        return cardStatusesConfig.types;
    },
    getStatusShowName(statusCode) {
        return this.getStatuses()[statusCode].showName;
    },
}


const cardSections = {
    getSections(){
        if( !cardSectionsConfig.sections ){
            return {};
        }
        return cardSectionsConfig.sections;
    },
    getSectionConfig(type){
        return this.getSections()[type];
    },
    getSectionShowName(type){
        return this.getSectionConfig(type).showName;
    },
    getSectionShowNameInCardCreate(type){
      if( this.getSectionConfig(type).showNameInCardCreate ){
        return this.getSectionConfig(type).showNameInCardCreate;
      }
      return this.getSectionConfig(type).showName;
    },
    getSectionColumns(type){
        return this.getSectionConfig(type).columnsConfig
          ? cardSectionsConfig[this.getSectionConfig(type).columnsConfig]
          : cardSectionsConfig.default_columns
    },

    isSectionMultiplyElementsBonus(type){
        return !!this.getSectionConfig(type).multiplyElementsBonus;
    },

    hideOnStagesIfEmpty(sectionType, stageType){
        if( this.getSectionConfig(sectionType).hideOnStagesIfEmpty === undefined ){
            return false;
        }
        return this.getSectionConfig(sectionType).hideOnStagesIfEmpty.includes(stageType);
    },

    getSectionsBlockHeaderTemplate() {
        if (!cardSectionsConfig.sectionsBlockHeaderTemplate) {
            return () => import(`@/components/cards/CardElementsBlock/CardSectionsBlockHeader`);
        }
        const templatePath = cardSectionsConfig.sectionsBlockHeaderTemplate;
        return () => import(`@/${templatePath}`);
    },
    getSectionsBlockFooterTemplate() {
        if (!cardSectionsConfig.sectionsBlockFooterTemplate) {
            return () => import(`@/components/cards/CardElementsBlock/CardSectionsBlockFooter`);
        }
        const templatePath = cardSectionsConfig.sectionsBlockFooterTemplate;
        return () => import(`@/${templatePath}`);
    },
    getAllowedScaleTypesForSections(sectionType){
        if( this.getSectionConfig(sectionType).allowedScaleTypes === undefined ){
            return Object.keys(scales.getScales());
        }
        return this.getSectionConfig(sectionType).allowedScaleTypes;
    },
}

const comment = {
  allowedExtensions() {
    return commentConfig?.attachments?.extensions || [];
  },
  isAutoSendCommentOnBlur(){
    return commentConfig?.is_auto_send_comment_on_blur === true;
  },
}

const scales = {
    getConfig(){
        return scalesConfig;
    },
    getScales(){
        return scalesConfig['scales'];
    },
    getScale(type){
        return this.getScales()[type];
    },

    getScalesForLibraryType(libraryType){
        // Нужно отфильтровать по разрешенным из конфигурации библиотеки
        const scalesToHide = libraries.getTypeConfig(libraryType).hideScales;
        if( !scalesToHide || scalesToHide.length < 1 ){
            return this.getScales();
        }

        return Object.keys(this.getScales())
          .filter(key => !scalesToHide.includes(key))
          .reduce((obj, key) => {
              obj[key] = this.getScales()[key];
              return obj;
          }, {});
    },

    getScaleConfig(scaleType){
        if( !scaleType ){
            return {};
        }
        return this.getScale(scaleType);
    },
    getScaleShowName(scaleType){
        if( !scaleType ){
            return '';
        }
        return this.getScale(scaleType).showName;
    },

    getScaleTemplate(scaleType, templateType){
        if( !scaleType ){
            return null;
        }
        if( this.getConfigurableScaleConfig() ){
            const baseTemplatesFolder = this.getConfigurableScaleConfig()['templatesFolder'] || 'components/configurableScales/templates';
            return () => import(`@/${baseTemplatesFolder}/${templateType}`);
        }

        return () => import(`@/${this.getScale(scaleType)['templatesFolder']}/${templateType}`);
    },

    getScalesSettingsTemplate(){
        // Оставляем возможность переопределить стандартный темплейт настроек шкал
        const baseSettingsTemplate = this.getConfig()['scale_settings_template'] || 'components/configurableScales/settings/ScalesSettings';

        return () => import(`@/${baseSettingsTemplate}`);
    },



    getConfigurableScaleConfig(){
        return this.getScale('configurable');
    },
    getConfigurableScaleSettingsTemplate(scaleType){
        if( !this.getConfigurableScaleConfig() ){
            return null;
        }
        if( !this.getConfigurableScaleConfig()['types'] ){
            return null;
        }
        if( !this.getConfigurableScaleConfig()['types'][scaleType] ){
            return null;
        }
        if( !this.getConfigurableScaleConfig()['types'][scaleType]['scopes_template'] ){
            return null;
        }
        return () => import(`@/${this.getConfigurableScaleConfig()['types'][scaleType]['scopes_template']}`);
    },
    getConfigurableScaleTemplate(scaleType, templateType){
        if( !scaleType ){
            return null;
        }
        if( !this.getConfigurableScaleConfig() ){
            return null;
        }

        // Оставляем возможность переопределить базовую папку темплейтов. Может быть пригодится
        const baseTemplatesFolder = this.getConfigurableScaleConfig()['templatesFolder'] || 'components/configurableScales/templates';

        return () => import(`@/${baseTemplatesFolder}/${scaleType}/${templateType}`);
    },
}

const massActions = {
    getEntities(){
        return massActionsConfig.entities;
    },
    getEntityActions(entityKey){
        if( !massActionsConfig.actions[entityKey] ){
            return [];
        }
        return massActionsConfig.actions[entityKey]
    },
    getReportBuilderEntityPreviewSettings(entityKey){
        return massActionsConfig.providers['report_builder']['entityPreviewSettings'][entityKey];
    },
    getActionTemplate(entityKey, actionKey){
        if( !this.getEntityActions(entityKey)[actionKey] ){
            return null;
        }
        return () => import(`@/${this.getEntityActions(entityKey)[actionKey].template}`);
    },
    getActionTemplateData(entityKey, actionKey){
        if( !this.getEntityActions(entityKey)[actionKey] ){
            return null;
        }
        return this.getEntityActions(entityKey)[actionKey].templateData || {};
    },
}


const matrix = {
    getConfig(){
        return matrixConfig;
    },
    getSummaryTemplate(){
        if( matrixConfig.summary_template){
            return () => import(`@/${this.getConfig().summary_template}`);
        }
        return () => import(`@/components/matrix/MatrixSummary`);
    },
    getSectionColumns(sectionType){
        return matrixConfig.sections_columns_config && matrixConfig.sections_columns_config[sectionType]
          ? matrixConfig[matrixConfig.sections_columns_config[sectionType]]
          : matrixConfig.default_columns
    },
}

const settings = {
    getTemplate(){
        let templatePath = settingsConfig.template;
        return () => import(`@/${templatePath}`);
    },

    getMenuTemplate(){
        let templatePath = settingsConfig.menu_template;
        if( !templatePath ){
            return null;
        }
        return () => import(`@/${templatePath}`);
    },
    getActionsTemplate(){
        let templatePath = settingsConfig.actions_template;
        if( !templatePath ){
            return null;
        }
        return () => import(`@/${templatePath}`);
    },

    getDefaultNumberFormat(){
        return {
            decimalPoint: settingsConfig.default_number_format?.decimal_point || ',',
            decimalLength: settingsConfig.default_number_format?.decimal_length || 2,
        }
    },

    getElementsNameMaxLength(){
        if( settingsConfig.elements_name_max_length === 0 ){
            return false;
        }
        return settingsConfig.elements_name_max_length ? settingsConfig.elements_name_max_length : 255;
    },
    getEnum(key) {
        if (settingsConfig.enums) {
            return settingsConfig.enums[key];
        }

        return [];
    },


    // Paginator
    getPaginatorPerPageSizes(){
      return settingsConfig?.paginator?.per_page_sizes || [10,25,50,100];
    },
    getPaginatorDefaultPerPage(){
      return settingsConfig?.paginator?.per_page_default || 10;
    },
    getPaginatorPerPageByName(paginatorName){
      const perPageByName = settingsConfig?.paginator?.per_page_by_name;
      if( !perPageByName || !perPageByName[paginatorName] ){
        return this.getPaginatorDefaultPerPage();
      }
      return perPageByName[paginatorName];
    },
}

const user = {
    getChiefTypes() {
        return Object.keys(userConfig.chief_types);
    },
    getChiefTypeShowName(type) {
        return userConfig.chief_types[type].showName;
    },
    getUsersListColumns(){
        return userConfig.users_list_columns;
    },
    getChiefsListColumns(){
        return userConfig.chiefs_list_columns;
    },

    isSelectByExcelEnabled(){
        return exportImport.getImportConfig('users_selection_by_excel')?.enabled || false;
    },

    getUsersListDefaultRoleFilterInSearch(){
        if( !userConfig.users_list_default_role_filter_in_search ){
            return null;
        }
        return userConfig.users_list_default_role_filter_in_search;
    },
}

const userDeputy = {
    getDeputiesPageColumns(){
        return userDeputyConfig.deputies_page_columns;
    },
}

const exportImport = {
    getImportConfigs() {
        return exportImportConfig.import;
    },
    getImportConfig(entity) {
        if( !exportImportConfig.import ){
            return [];
        }
        return exportImportConfig.import[entity] || [];
    },
    getExportConfigs() {
        return exportImportConfig.export;
    },
}

const auth = {
    ensureVueIsLoaded() {
        return new Promise(function (resolve, reject) {
            (function waitForFoo(){
                if (VueObject.prototype.$config) return resolve();
                setTimeout(waitForFoo, 30);
            })();
        });
    },
    async getEnabledAuthMethods(){
        await this.ensureVueIsLoaded();
        return VueObject?.prototype?.$config?.auth?.visible_auth_methods;
    },
    getAuthMethodConfig(authMethodName){
        return VueObject?.prototype?.$config?.auth?.auth_methods[authMethodName];
    },
    getAuthMethodTemplate(authMethodName){
        if( !this.getAuthMethodConfig(authMethodName)){
            return null;
        }
        if( this.getAuthMethodConfig(authMethodName).template){
            return () => import(`@/${this.getAuthMethodConfig(authMethodName).template}`);
        }
        return () => import(`@/auth/methods/${authMethodName}`);
    },
    isRefreshEnabledForMethod(authMethodName){
        if( !VueObject?.prototype?.$config?.auth?.auth_methods[authMethodName] ){
            return false;
        }
        return !!VueObject?.prototype?.$config?.auth?.auth_methods[authMethodName].useRefreshToken;
    },
}

const i18n = {
    t(scope, key, defaultValue, templateArgs = {}, type = null) {
        let template = null;
        const scopeConfig = i18nConfig?.[scope];

        if (scopeConfig) {
            if (type && scopeConfig.per_type?.[type]?.[key]) {
                template = scopeConfig.per_type[type][key];
            } else if (scopeConfig[key]) {
                template = scopeConfig[key];
            }
        }

        if (!template) {
            template = defaultValue ?? `${scope}-${key}`;
        }

        if (templateArgs && Object.keys(templateArgs).length > 0) {
            return template.replace(/\$([\w]+)/g, (_, word) =>
                templateArgs[word] ?? word
            );
        }

        return template;
    }
};

const home = {
    getWidgets(){
        if( !homeConfig || !homeConfig.widgets ){
            return [];
        }
        return homeConfig.widgets
    },
    getWidgetConfig(widgetKey){
        if( !homeConfig || !homeConfig.widgets || !homeConfig.widgets[widgetKey] ){
            return [];
        }
        return homeConfig.widgets[widgetKey]
    },

    getColors(){
       return homeConfig.colors;
    }
}

const cascading = {
  isEnabled() {
      return cascadingConfig.enabled || false;
  },
  getSectionShowName() {
    return cascadingConfig?.card_section?.showName || '';
  },
  getSectionEmptyText() {
    return cascadingConfig?.emptyText || '';
  },
  getSectionColumns() {
    return cascadingConfig?.card_section?.columns || [];
  },
}


const helpers = {
    getTableColumnsArrayFromConfig(columnsConfig) {
        let toReturn = [];
        columnsConfig.forEach((columnConfig) => {
            toReturn.push(this.prepareTableColumnConfig(columnConfig));
        });
        return toReturn;
    },

    prepareTableColumnConfig(columnConfig){
        return {
            prop: columnConfig.prop,
            label: columnConfig.label,
            template: columnConfig.template
              ? () => import(`@/${columnConfig.template}`)
              : false,
            width: columnConfig.width ? columnConfig.width : null,
            minWidth: columnConfig.minWidth ? columnConfig.minWidth : null,
            fixed: !!columnConfig.fixed,
            className: columnConfig.className ? columnConfig.className : null,
            labelClassName: columnConfig.labelClassName ? columnConfig.labelClassName : null,
            align: columnConfig.align ? columnConfig.align : null,
            showOnStages: columnConfig.showOnStages,
            showOnStagesWhileNoNegotiation: columnConfig.showOnStagesWhileNoNegotiation,
            showOnCompleted: columnConfig.showOnCompleted,
            showOnStatuses: columnConfig.showOnStatuses,
            popover: columnConfig.popover,
            manualColumnTemplate: columnConfig.manualColumnTemplate ? true : null,
            getVif: (templateData) => {
                if( columnConfig.if === undefined ) return true;
                return eval(columnConfig.if)
            },
            getBind: (templateData, scope) => {
                let toReturn = {};
                if( !columnConfig.bind ) return toReturn;
                for (const [key, value] of Object.entries(columnConfig.bind)) {
                    toReturn[key] = eval(value);
                }
                return toReturn;
            },
            getVon: (templateData, scope) => {
                let toReturn = {};
                if( !columnConfig.on ) return toReturn;
                for (const [key, value] of Object.entries(columnConfig.on)) {
                    toReturn[key] = eval(value);
                }
                return toReturn;
            },
        }
    },


    getObjectPropByString(o, s) {
        s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        s = s.replace(/^\./, '');           // strip a leading dot
        let a = s.split('.');
        for (let i = 0, n = a.length; i < n; ++i) {
            let k = a[i];
            if (o && k in o) {
                o = o[k];
            } else {
                return;
            }
        }
        return o;
    },

    getDateLocale(){ return 'ru-RU' },
    getDateLocaleOptions(){ return {} },

    buildUrl(url, parameters) {
        let qs = "";
        for (let key in parameters) {
            let value = parameters[key];
            qs += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&";
        }
        if (qs.length > 0) {
            qs = qs.substring(0, qs.length - 1); //chop off last "&"
            url = url + "?" + qs;
        }
        return url;
    }
}




const companyConfiguration = {
    evaluation,
    talentMatrix,
    knowledgeBase,
    libraries,
    card,
    cardStages,
    cardStageNegotiations,
    cardStatuses,
    cardSections,
    comment,
    scales,
    massActions,
    matrix,
    settings,
    user,
    userDeputy,
    auth,
    exportImport,
    helpers,
    i18n,
    home,
    cascading,
}

let VueObject;
export default {
    install(Vue) {
        VueObject = Vue;
        Vue.prototype.$companyConfiguration = companyConfiguration;
    },
    configs: companyConfiguration,
}